import React from "react";

export default function Privacy() {
  return (
    <>
      <style>{`
        .doc-page {
          max-width: 900px;
          margin: 0 auto;
          padding: 40px 20px 80px;
          animation: fadeDoc 0.4s ease;
        }

        @keyframes fadeDoc {
          from { opacity: 0; transform: translateY(10px); }
          to { opacity: 1; transform: translateY(0); }
        }

        .doc-page h2 {
          font-size: 36px;
          margin-bottom: 10px;
        }

        .doc-page > p:first-of-type {
          font-size: 14px;
          opacity: 0.6;
          margin-bottom: 30px;
        }

        .doc-page p {
          font-size: 15px;
          line-height: 1.7;
          margin-bottom: 18px;
          opacity: 0.9;
        }

        .doc-page h3 {
          font-size: 20px;
          margin-top: 36px;
          margin-bottom: 10px;
          position: relative;
          padding-left: 12px;
        }

        .doc-page h3::before {
          content: "";
          position: absolute;
          left: 0;
          top: 6px;
          width: 4px;
          height: 16px;
          background: #22c55e;
          border-radius: 2px;
        }

        .doc-page a {
          color: #22c55e;
          text-decoration: none;
          font-weight: 500;
        }

        .doc-page a:hover {
          text-decoration: underline;
        }

        @media (max-width: 768px) {
          .doc-page h2 {
            font-size: 28px;
          }

          .doc-page h3 {
            font-size: 18px;
          }
        }
      `}</style>

      <div className="container doc-page">
        <h2>Privacy Policy</h2>
        <p>Last updated: January 2026</p>

        <p>
          Sportyfo (“we”, “us”, or “our”) values your privacy. This Privacy Policy
          explains how we collect, use, store, and protect your information when
          you use the Sportyfo mobile application and related services.
        </p>

        <h3>1. Information We Collect</h3>
        <p>
          We collect information that you voluntarily provide and information
          generated through your use of the app, including:
        </p>
        <p>
          • Account information such as name, email address, and login details  
          <br />
          • Profile details and badminton match data (scores, matches played,
          performance statistics)  
          <br />
          • Device and usage information (app interactions, crash logs,
          diagnostics)  
          <br />
          • Location data, only when you choose to share it (for match location
          and nearby player features)
        </p>

        <h3>2. How We Use Your Information</h3>
        <p>
          We use your information to operate and improve Sportyfo, including:
        </p>
        <p>
          • Creating and managing your account  
          <br />
          • Tracking matches and displaying performance insights  
          <br />
          • Enabling social and competitive features  
          <br />
          • Improving app stability, security, and user experience  
          <br />
          • Communicating important updates related to the app
        </p>

        <h3>3. Third-Party Services</h3>
        <p>
          Sportyfo may use trusted third-party services such as Google Sign-In,
          analytics, and crash reporting tools. These services may collect
          information according to their own privacy policies. We do not control
          how third parties handle your data.
        </p>

        <h3>4. Data Sharing</h3>
        <p>
          We do not sell, rent, or trade your personal data. Your information is
          shared only when necessary to operate the app or comply with legal
          obligations.
        </p>

        <h3>5. Data Storage and Security</h3>
        <p>
          We take reasonable measures to protect your information using
          industry-standard security practices. However, no method of
          transmission or storage is completely secure.
        </p>

        <h3>6. Your Rights and Choices</h3>
        <p>
          You have the right to access, update, or request deletion of your
          personal data. You may contact us at{" "}
          <a href="mailto:sportyfo.official@gmail.com">
            sportyfo.official@gmail.com
          </a>{" "}
          to submit a request.
        </p>

        <h3>7. Account Deletion</h3>
        <p>
          You may request permanent deletion of your Sportyfo account and
          associated data by contacting us via email. We will process deletion
          requests within a reasonable timeframe.
        </p>

        <h3>8. Children’s Privacy</h3>
        <p>
          Sportyfo is not intended for children under the age of 13. We do not
          knowingly collect personal information from children. If we become
          aware of such data, it will be deleted immediately.
        </p>

        <h3>9. Changes to This Policy</h3>
        <p>
          We may update this Privacy Policy from time to time. Any changes will
          be posted on this page with an updated revision date.
        </p>

        <h3>10. Contact Us</h3>
        <p>
          If you have questions or concerns about this Privacy Policy, please
          contact us at{" "}
          <a href="mailto:sportyfo.official@gmail.com">
            sportyfo.official@gmail.com
          </a>.
        </p>
      </div>
    </>
  );
}
